import React from 'react'
import { CurriculumProps } from '../../types/table'
import Table from '../common/Table'

interface CurriculumItemProps {
  curriculum: CurriculumProps
  index: number
}

const CurriculumVideoItem: React.FC<CurriculumItemProps> = ({
  curriculum,
  index,
}) => {
  return (
    <tr key={index}>
      <Table.Cell>{curriculum.level}</Table.Cell>
      <Table.Cell>{curriculum.mainChapter}</Table.Cell>
      <Table.Cell>{curriculum.subChapter}</Table.Cell>
      <Table.Cell>{curriculum.unit}</Table.Cell>
      <Table.Cell>{curriculum.detailUnit}</Table.Cell>
      <Table.Cell>{curriculum.contentType}</Table.Cell>
      <Table.Cell>{curriculum.questionLabel}</Table.Cell>
    </tr>
  )
}

export default CurriculumVideoItem
